export const CMP_SNIPPET_TEMPLATE = `<!-- START TNC CMP - {{PROVIDER_NAME}} (ProviderID: {{PROVIDER_ID}}) -->
<script src="{{CMP_JS_URL}}"></script>
<!-- END TNC CMP -->

<!--
  L'oggetto window.TncConsent è disponibile dopo il caricamento dello script.

  Metodi principali:
    window.TncConsent.showPreferences()     // apre il pannello preferenze
    window.TncConsent.withdrawConsent()     // revoca il consenso e mostra il banner
    window.TncConsent.getConsentData()      // restituisce i dati di consenso correnti
    window.TncConsent.getTCString()         // restituisce la TC String IAB
    window.TncConsent.acceptAll()           // accetta tutto via codice
    window.TncConsent.rejectAll()           // rifiuta tutto via codice

  Eventi DOM:
    window.addEventListener('TncConsentReady', (e) => {
      // Fired al caricamento: consenso già presente o banner mostrato
      console.log('CMP pronta. Consenso esistente:', e.detail.hasConsent);
      console.log('TC String:', e.detail.tcString);
    });

    window.addEventListener('TncConsentUpdated', (e) => {
      // Fired ogni volta che l'utente salva le preferenze
      console.log('Consenso aggiornato:', e.detail.consentData);
      console.log('TC String:', e.detail.tcString);
    });

  Esempio callback su salvataggio consenso (configurabile nel pannello CMP):
    function onConsentSaved(consentData) {
      console.log('Consenso salvato:', consentData);
    }
-->`;
